import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import DashboardHeader from '../../components/navigation/DashboardHeader'; 
import HomeInventoryContent from './components/HomeInventoryContent';
import OrizonFooter from './components/OrizonFooter'; 

const AcvHomePage = () => {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({ nome: '', ruolo: '' });

  useEffect(() => {
    fetchAdminData();
  }, []);

  const fetchAdminData = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profilo } = await supabase
          .from('profili')
          .select('nome, cognome, ruolo')
          .eq('id', user.id)
          .single();
        
        if (profilo) {
          setAdminData({ 
            nome: `${profilo.nome} ${profilo.cognome}`, 
            ruolo: profilo.ruolo 
          });
        }
      }
    } catch (err) { 
      console.error("Errore caricamento dati:", err); 
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col gap-y-4 md:gap-y-6">
      
      <DashboardHeader />

      <main className="flex-grow w-full">
        {/* 
            PROSTOR I RESPONSIVE POPRAVKA:
            - pt-28 (na mobitelu) - Povećano sa pt-16 da title ne upada pod header
            - md:pt-36 (na desktopu) - Povećano sa pt-28 za još bolju preglednost
        */}
        <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-28 md:pt-36 pb-12 lg:pb-24">
          <HomeInventoryContent />
        </div>
      </main>

      <OrizonFooter />
    </div>
  );
};

export default AcvHomePage;